export default class DefaultBill {
    id: number;
    userId: number;
    defaultBillRate: number;
    defaultBillUnit: string;
    isActive: boolean;
    createdDate: Date;
    createdBy?: string;
}


// WEBPACK FOOTER //
// ./src/models/personnel/DefaultBill.ts